import React from "react"

import Caption from "../../../../design-system/caption"
import LinkWithArrow from "../../../../design-system/link-with-arrow"
import Paragraph from "../../../../design-system/paragraph"
import UniversalLink from "../../../../design-system/universal-link"
import { Viewport } from "../../../../utils/constants"
import { useLocale } from "../../../../utils/hooks/use-locale"
import { DatoImage } from "../../../dato-image"
import { resolveLinkHref } from "../../../seo/canonical-tag/utils"
import * as styles from "./index.module.scss"
import { Category, useFeaturedContent } from "./use-featured-content"

type Props = {
  category: Category
}

const DropdownHighlight = ({ category }: Props) => {
  const locale = useLocale()
  const feature = useFeaturedContent(category)
  const getLinkProps = (position: string) => ({
    to: resolveLinkHref(feature.linkUrl, locale),
    trackingProperties: {
      name: feature.title,
      location: `nav-dropdown-highlight`,
      navCategory: category,
      position,
    },
  })

  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <Caption className={styles.title}>{feature.title}</Caption>
        <div className={styles.contentWrapper}>
          <UniversalLink {...getLinkProps("image")} tabIndex={-1}>
            <DatoImage
              absolutePositioned
              className={styles.image}
              data={{
                width: 224,
                height: 137,
                src: `${feature.thumbnail.url}?auto=format&fit=max&dpr=2&q=10`,
              }}
              srcSetCandidates={[
                { imgWidth: 160, minViewport: 0 },
                { imgWidth: 224, minViewport: Viewport.xsmall },
              ]}
            />
          </UniversalLink>
          <div className={styles.text}>
            <UniversalLink
              {...getLinkProps("description")}
              className={styles.descriptionLink}
              tabIndex={-1}
            >
              <Paragraph variant="2" className={styles.description}>
                {feature.description}
              </Paragraph>
            </UniversalLink>
            <LinkWithArrow
              {...getLinkProps("cta")}
              text={feature.linkText}
              variant="2"
              className={styles.link}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default DropdownHighlight
